import showNotification from './notification';

const errorNotification = (message = 'Error') =>
  showNotification({ type: 'error', message });

export default errorNotification;
